import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

export interface RejectCallDialogResult {
  confirmed: true;
  reason: string | null;
}

@Component({
  selector: 'app-reject-call-dialog',
  templateUrl: './reject-call-dialog.component.html',
})
export class RejectCallDialogComponent {
  reasonControl = new FormControl('');

  constructor(private dialogRef: MatDialogRef<RejectCallDialogComponent>) {}

  confirm(): void {
    const reasonValue = this.reasonControl.value;
    const reason = reasonValue && reasonValue.trim() ? reasonValue.trim() : null;
    this.dialogRef.close({ confirmed: true, reason } as RejectCallDialogResult);
  }

  cancel(): void {
    this.dialogRef.close(undefined);
  }
}
